import React from 'react';
import {
  Card,
  CardBody, CardFooter, Row, Col,
  UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem  } from "reactstrap";

import './styles.css';

var Utils = require ('Utils');
var Const = require ('Const');
 
const courseActions = ( courseSubjectID) => {
  return (
    <UncontrolledDropdown 
          // className="btn-rotate"
           >
        <DropdownToggle
          // aria-haspopup={true}
          caret
          color="default"
          data-toggle="dropdown"
          id="navbarDropdownMenuLink"
        >
          Acciones
        </DropdownToggle>
        <DropdownMenu
          persist
          aria-labelledby="navbarDropdownMenuLink"
          left
        >
                <DropdownItem href={"/admin/my-courses/"+courseSubjectID} >
                  Administrar
                </DropdownItem>
                <DropdownItem href={"/admin/my-courses/"+courseSubjectID+"/notebook"} >
                  Cuaderno del profesor
                </DropdownItem>
                <DropdownItem href={"/admin/my-courses/"+courseSubjectID+"/calif"} >
                  Calificaciones
                </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
  )
}


const CourseSubjectCard = ( { courseSubject } ) =>  {

    return (
              <Card
                className={ "cover-image-card"}
                style={{ backgroundImage: 'url("' + (courseSubject.cover_image?courseSubject.cover_image:Utils.defaultCover()) + '")' }}
                >
              <CardBody>
                <Row>
                  <Col md="12" >
                      <p className="curso">{Utils.capitalize(courseSubject.course_short_name)}</p>
                      <p className="turno">Turno {courseSubject.shift_name}</p>
                      <p className="materia-teacher">{Utils.capitalize(courseSubject.subject_name)}</p>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <Row>
                  <Col md="7">
                    <div className="horarios">
                      <i className="fa fa-calendar" />
                        { courseSubject.schedule.map( (sch, idx) => {
                          return ( (idx>0?" - ":"") + Const.WEEK_DAYS_SHORT[sch.week_day-1] + " de " + sch.start_time.slice(0,5) 
                                    + " a " + sch.end_time.slice(0,5) )
                          }
                        )
                        }
                    </div>
                  </Col>
                
                  <Col md="5" >
                    <div class="float-right">

                        <div class="float-right">
                        { courseActions( courseSubject.course_subject_id ) }
                      </div>
                      {/* <Link 
                        className="btn"
                        to={"/admin/my-courses/"+courseSubject.course_subject_id}
                            >
                          Ingresar
                      </Link> */}
                    </div>
                  </Col>
                </Row>
              </CardFooter>
            </Card>

            )
  };

export { CourseSubjectCard } ;
